import useEventBus from '@/composables/useEventBus';

declare const window: any;
const eventBus = useEventBus();

export default class MatomoService {
    constructor() {
        eventBus.on('login', this.loginListener);
    }

    loginListener = (e) => {
        if (window._paq) {
            window._paq.push(['setUserId', e?.user?.id]);
            window._paq.push(['trackPageView']);
        }

        // Will stop listening to login event
        eventBus.off('login', this.loginListener);
    };
}
